import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdaService } from 'src/app/shared/services/pda.service';
import { Alert } from 'src/app/shared/models/alert.model';
@Component({
  selector: 'app-methods',
  templateUrl: './methods.component.html',
  styleUrls: ['./methods.component.scss'],
})
export class MethodsComponent implements OnInit {
  @Input() title: any;
  @Input() from: string;
  @Input() data: any;
  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();
  @Output() clickReturn = new EventEmitter();
  methods = [];
  selectedMethod: any = [];
  select: string;
  constructor(
    public activeModal: NgbActiveModal,
    private _translate: TranslateService,
    private modalService: NgbModal,
    private pda: PdaService
  ) {}

  ngOnInit(): void {
    this.methods = [
      {
        id: 1,
        titulo: this._translate.instant(
          'action_plan.analisis.methods_diagram.ishikawa_diagram'
        ),
      },
      {
        id: 3,
        titulo: this._translate.instant(
          'action_plan.analisis.methods_diagram.pareto_chart'
        ),
      },
      {
        id: 2,
        titulo: this._translate.instant(
          'action_plan.analisis.methods_diagram.five_why_diagram'
        ),
      },
      {
        id: 4,
        titulo: this._translate.instant(
          'action_plan.analisis.methods_diagram.brainstorm'
        ),
      },
    ];
    if (this.data.length) {
      this.data.forEach((method_selected, index, array) => {
        this.methods.forEach((method_list, index2, array) => {
          if (method_selected.id == method_list.id) {
            this.methods.splice(index2, 1);
          }
        });
      });
    }
    if (this._translate.currentLang == 'es') {
      this.select = 'Seleccione el método de análisis';
    } else {
      this.select = 'Select analysis method';
    }
  }
  selectMethod() {}
  btnClose() {
    this.clickClose.emit({ id: this.selectedMethod });
    this.activeModal.close();
  }

  btnDismiss() {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }
}
